import React, {useEffect, useState} from 'react';
import {toast} from 'sonner';
import {network} from '../lib/network';
import {UtilitySchemas} from '@plunk/shared';
import {NextSeo} from 'next-seo';
import {Footer, Modal, Navbar} from '../components';
import {motion} from 'framer-motion';
import {Editor} from '../components/MarkdownEditor';
import Prism from 'prismjs';

/**
 *
 */
export default function Index() {
  const [value, setValue] = useState('');

  const [html, setHtml] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const highlight = async () => {
      await Prism.highlightAll(); // <--- prepare Prism
    };
    void highlight(); // <--- call the async function
  }, []);

  const convert = () => {
    toast.promise(network.fetch<string, typeof UtilitySchemas.convert>('POST', '/utils', {markdown: value}), {
      loading: 'Converting markdown to HTML',
      success: html => {
        setHtml(html);
        setShowModal(true);

        return 'Converted markdown to HTML';
      },
      error: 'Error converting markdown to HTML',
    });
  };

  return (
    <>
      <NextSeo
        title={'Markdown to responsive email HTML | The Open-Source Email Platform'}
        description={'Easily turn markdown into beautiful, responsive emails that everyone wants to read.'}
        openGraph={{
          title: 'Markdown to responsive email HTML | The Open-Source Email Platform',
          description: 'Easily turn markdown into beautiful, responsive emails that everyone wants to read.',
        }}
        additionalMetaTags={[
          {
            property: 'title',
            content: 'Markdown to responsive email HTML | The Open-Source Email Platform',
          },
        ]}
      />
      <Modal
        title={'Hey there!'}
        description={
          'Did you know this editor is integrated into Plunk? Consider switching to Plunk so you can ditch this clunky copy and pasting!'
        }
        type={'info'}
        isOpen={showModal}
        onToggle={() => {
          setHtml('');
          setShowModal(false);
        }}
        action={'Copy HTML to clipboard'}
        onAction={async () => {
          await navigator.clipboard.writeText(html);
          toast.success('Copied to clipboard');
        }}
      >
        <>
          <div className={'my-3 max-w-md text-sm'}>
            <pre className={'h-52 overflow-x-hidden overflow-y-scroll rounded'}>
              <motion.pre layout className={'w-full overflow-x-hidden rounded-xl p-6'}>
                <motion.code layout className="language-javascript font-mono font-medium">
                  {html}
                </motion.code>
              </motion.pre>
            </pre>
          </div>
        </>
      </Modal>
      <Navbar />

      <div className={'mx-auto max-w-7xl px-8 sm:px-0'}>
        <main>
          <div className={'mb-4 flex flex-col items-center justify-center gap-y-2'}>
            <div className={'mt-6 text-center'}>
              <h1 className="text-4xl font-bold text-neutral-800">Markdown to responsive email HTML</h1>
              <p className="mx-auto mt-2 max-w-lg text-neutral-500">
                Easily turn markdown into beautiful, responsive emails that everyone wants to read.
              </p>
            </div>
          </div>

          <div className={'mx-auto w-full max-w-3xl p-6'}>
            <Editor value={value} onChange={val => setValue(val)} />
          </div>

          <div className={'mt-9 flex items-center justify-center'}>
            <motion.button
              onClick={() => convert()}
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.9}}
              className={'h-full rounded-lg bg-neutral-800 px-12 py-3 text-sm font-semibold text-white'}
            >
              Convert to HTML
            </motion.button>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
}
